/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Hero_Title_LeadInputs */

const en_features_hero_title_lead = /** @type {(inputs: Features_Hero_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your whole coaching business,`)
};

const pl_features_hero_title_lead = /** @type {(inputs: Features_Hero_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały Twój biznes trenerski,`)
};

/**
* | output |
* | --- |
* | "Your whole coaching business," |
*
* @param {Features_Hero_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_hero_title_lead = /** @type {((inputs?: Features_Hero_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Hero_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_hero_title_lead(inputs)
	return en_features_hero_title_lead(inputs)
});